import { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import { getLabels } from '../../../../utils/LabelFormatter/SingleLabelFormatter/UTurnLabelFormatter';
import { getFilterMetadata } from '../../FilterChainUtils';
import { GenericRadioFilter } from '../GenericBloc/GenericRadioFilter/GenericRadioFilter';
import type { AbstractSingleFilterPillsProps } from '../SingleFilterType';
import { OPTION_LIST } from './UTurnFilterConstant';
import type { U_TURN_TYPE } from './UTurnFilterType';

export function UTurnFilter({
  autoFocus,
  currentValue,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
}: AbstractSingleFilterPillsProps<U_TURN_TYPE>): JSX.Element {
  const metadata = getFilterMetadata(FilterKindEnum.UTurnKind);
  const { label1, label2 } = getLabels(currentValue);
  return (
    <GenericRadioFilter
      autoFocus={autoFocus}
      filterName={metadata.filterName}
      iconName={metadata.iconName}
      currentValue={currentValue}
      onApply={onApply}
      onRemove={onRemove}
      optionList={OPTION_LIST}
      label1={label1}
      label2={label2}
      onDropdownHidden={onDropdownHidden}
      showDropdownOnMount={showDropdownOnMount}
      header="Sessions with users who quickly went back out of confusion after visiting a new page."
    />
  );
}
